export const capitalizeFirstLetter = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const getParamsWithComma = array => {
  return array.reduce((acc, item) => `${acc ? `${acc},` : ''}${item}`, '');
};
